import React, { Component } from 'react';

export class AddRemoveButtons extends Component {
  render() {
    return (
      <div>
        <button
          className={`btn btn-success ${this.props.btnSize}`}
          onClick={this.props.onAddAll}>{`Add All >>`}
        </button>
        <button
          className={`btn btn-success ${this.props.btnSize}`}
          onClick={this.props.onAdd}
          disabled={this.props.disableAdd}>{`Add >`}
        </button>
        <button
          className={`btn btn-danger ${this.props.btnSize}`}
          onClick={this.props.onRemove}
          disabled={this.props.disableRemove}>{`< Remove`}
        </button>
        <button
          className={`btn btn-danger ${this.props.btnSize}`}
          onClick={this.props.onRemoveAll}>{`<< Remove All`}
        </button>
      </div>
    )
  }
}
